module.exports = __webpack_public_path__ + "img/logo.60519e40.svg";